import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useCallback } from 'react';
import { Box } from '@atlaskit/primitives';
import PlatformCheckbox from '@atlaskit/checkbox';
/**
 * A Checkbox group is a list of options where one or more choices can be selected.
 */
export var CheckboxGroup = function CheckboxGroup(props) {
  var _ref = props.forgeDoc.props,
    name = _ref.name,
    options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? [] : _ref$defaultValue,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
  var _useState = useState(value !== null && value !== void 0 ? value : defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    selectedValues = _useState2[0],
    setSelectedValues = _useState2[1];
  useEffect(function () {
    if (value) {
      setSelectedValues(value);
    }
  }, [value]);
  var notStaticCheckbox = !value || onChange;
  var onCheckboxChange = useCallback(function (event) {
    if (notStaticCheckbox) {
      var newSelectedValues = selectedValues.includes(event.target.value) ? selectedValues.filter(function (item) {
        return item !== event.target.value;
      }) : [].concat(_toConsumableArray(selectedValues), [event.target.value]);
      setSelectedValues(newSelectedValues);
      if (onChange) {
        onChange(newSelectedValues);
      }
    }
  }, [notStaticCheckbox, onChange, selectedValues, setSelectedValues]);
  return /*#__PURE__*/React.createElement(Box, {
    role: "group"
  }, options.map(function (item, index) {
    var _item$isDisabled;
    return /*#__PURE__*/React.createElement(PlatformCheckbox, {
      key: index,
      name: name,
      value: item.value,
      label: item.label,
      isChecked: selectedValues.includes(item.value),
      isDisabled: (_item$isDisabled = item.isDisabled) !== null && _item$isDisabled !== void 0 ? _item$isDisabled : isDisabled,
      onChange: onCheckboxChange
    });
  }));
};